import React from 'react'

import { Button, Link, Variants } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import ContactModal from 'modules/billing/components/ContactModalPage'
import useContactSales from 'modules/billing/hooks/useContactSales'

type Props = {
  type?: Variants
  ctaLabel?: string
  contactReason?: 'upgrade' | 'default'
  emitEventHandler: () => void
}

const ContactSales = ({
  ctaLabel,
  type = 'primary',
  contactReason = 'default',
  emitEventHandler,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const isUpgradeRequested = contactReason === 'upgrade'
  const { handleClick } = useContactSales()

  const onSuccess = () => {
    setIsModalOpen(true)
    emitEventHandler()
  }

  return (
    <>
      {ctaLabel ? (
        <Button type={type} onClick={() => handleClick(onSuccess)}>
          {ctaLabel}
        </Button>
      ) : (
        <Link.Touchable onClick={() => handleClick(onSuccess)}>
          {i18n.t('pricing_plans.contact_us')}
        </Link.Touchable>
      )}
      {isModalOpen && (
        <ContactModal isUpgrade={isUpgradeRequested} onClose={() => setIsModalOpen(false)} />
      )}
    </>
  )
}

export default ContactSales
